const initials = "notification/";

export const UPDATE_NOTIFICATION_REDUCER = `${initials}UPDATE_NOTIFICATION_REDUCER`;